import React, { Component } from 'react';
import {Box, AppBar, Toolbar, Container} from '@mui/material';
import { connect } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core';
// import themeV2 from 'theme';

import ThemeCustomization from 'themes';
import { createTheme } from '@mui/material/styles';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import MainContentStyled from './MainContentStyled';
import DiscoverInfluencer from './components/InfluencerDiscover';
import DiscoverInfluencerV2 from './components/InfluencerDiscoverV2';
import UniqueReachSection from './components/UniqueReachSection';
import CuratedList from './components/CuratedList';
import CuratedInfluencers from './components/CuratedInfluencers';
import InfluencerInsight from './components/InfluencerInsight';
import PremiunFeature from './components/PremiunFeature';
import InsightFrame from './components/InfluencerInsight/Insightframe';
import PlannerList from './components/PlannerList';
import config, { MenuOrientation } from 'config'
import { updateUser } from 'actions/planner2';
import 'assets/scss/style.scss';
import PlanInfluencers from './components/PlanInfluencerList';
import HelpAndSupport from './components/HelpAndSupport';
import InvoiceDashboard from '../invoices/InvoiceDashboard';
import InvoiceWorkspace from '../invoices/InvoiceWorkspace';
import StaffOnly from '../../customRoutes/StaffOnly';
import MyFeedback from '../feedback/MyFeedback';
import PlannerNotFound from './components/NotFound';
import VideoQcPage from './components/VideoQC/VideoQcPage';


const {borderRadius, container, menuOrientation} = config
const isHorizontal = menuOrientation === MenuOrientation.HORIZONTAL
const theme = createTheme();

class Planner extends Component {

  componentDidMount() {
    const { pathname } = this.props.location;
    const collabPattern = new RegExp(`/planner/collab-list/[^/]+/influencers/[^/]+`);
    const accessToken = localStorage.getItem('access')
    if(accessToken === null){
      if (!collabPattern.test(pathname)) {
        this.props.updateUser();
      }
    }else{
      this.props.updateUser();
    }

    // Listen for navigation messages from iframe
    this.handleIframeMessage = (event) => {
      if (event.data && event.data.type === 'COMPETITOR_REPORT_NAVIGATE') {
        const { path } = event.data;
        // Only update if the path is different to avoid infinite loops
        if (this.props.location.pathname + this.props.location.search !== path) {
          this.props.history.push(path);
        }
      }
    };

    window.addEventListener('message', this.handleIframeMessage);
  }

  componentWillUnmount() {
    if (this.handleIframeMessage) {
      window.removeEventListener('message', this.handleIframeMessage);
    }
  }

  render() {
    console.log("Index Route User: ", this.props)
    // Destructure state
    const { drawerOpen } = this.props;
    console.log('props',this.props)
    return (
      <ThemeCustomization>
        <Box sx={{ display: 'flex' }}>
            <AppBar enableColorOnDark position="fixed" color="inherit" elevation={0} sx={{ bgcolor: 'background.default' }}>
                <Toolbar sx={{ p: isHorizontal ? 1.25 : 2 }}>
                    <Header /> 
                </Toolbar>
            </AppBar>
            <Sidebar />

            <MainContentStyled {...{ borderRadius, menuOrientation, open: drawerOpen, theme }}>
              <Container maxWidth={container ? 'lg' : false} {...(!container && { sx: { px: { xs: 0 } } })}>
                <Switch>
                  <Route path={`${this.props.match.path}/discover-v2`} component={DiscoverInfluencerV2}/>
                  <Route path={`${this.props.match.path}/discover-v1`} component={DiscoverInfluencer}/>
                  <Route path={`${this.props.match.path}/unique-reach`} component={UniqueReachSection}/>
                  <Route path={`${this.props.match.path}/discover`} component={DiscoverInfluencerV2}/>
                  <Route path={`${this.props.match.path}/video-qc/:campaignId?`} component={VideoQcPage} />
                  <Route path={`${this.props.match.path}/curated-list/:curatedItemId`} component={CuratedInfluencers } />
                  <Route path={`${this.props.match.path}/curated-list`} component={CuratedList } />
                  <Route path={`/planner/collab-list/:listName/influencers/:planUUID`} component={ PlanInfluencers } />
                  <Route path={`${this.props.match.path}/collab-list`} component={PlannerList } />
                  <Route path={`${this.props.match.path}/insight/:id`} component={InfluencerInsight}/>
                  <Route path={`/planner/profile-details/:platform/:handle`} component={InsightFrame}></Route>
                  <Route path={`${this.props.match.path}/help-and-support`} component={HelpAndSupport}></Route>
                  {/* What this person has asked for, and where each ask got
                      to. The staff board is a separate top-level route. */}
                  <Route path={`${this.props.match.path}/feedback`} component={MyFeedback}></Route>
                  {/* The accounts team's invoice console lives inside the
                      planner shell so it keeps the header and sidebar. */}
                  {/* Before /invoices, which is not exact and would match
                      this path first. */}
                  <Route
                    path={`${this.props.match.path}/invoices/workspace`}
                    render={() => (
                      <StaffOnly>
                        <InvoiceWorkspace />
                      </StaffOnly>
                    )}
                  />
                  <Route
                    path={`${this.props.match.path}/invoices`}
                    render={() => (
                      <StaffOnly>
                        <InvoiceDashboard />
                      </StaffOnly>
                    )}
                  />
                  <Route path={`${this.props.match.path}/campaign/:campaignId`}
                    render={({ match }) => {
                      const { campaignId } = match.params;
                      const token = localStorage.getItem('access');
                      const sparkleUrl = `https://campaign-design.d1bsdtx7tgg12i.amplifyapp.com/campaign/${campaignId}/${token ? `?token=${token}` : ''}`;
                      return (
                        <Box sx={{ width: '100%', height: 'calc(100vh - 64px)', border: 'none' }}>
                          <iframe
                            src={sparkleUrl}
                            style={{
                              width: '100%',
                              height: '100%',
                              border: 'none',
                              display: 'block'
                            }}
                            title="Campaign Dashboard"
                          />
                        </Box>
                      );
                    }}
                  />
                  <Route path={`${this.props.match.path}/campaign`}
                    render={() => {
                      const token = localStorage.getItem('access');
                      const sparkleUrl = `https://campaign-design.d1bsdtx7tgg12i.amplifyapp.com/${token ? `?token=${token}` : ''}`;
                      return (
                        <Box sx={{ width: '100%', height: 'calc(100vh - 64px)', border: 'none' }}>
                          <iframe
                            src={sparkleUrl}
                            style={{
                              width: '100%',
                              height: '100%',
                              border: 'none',
                              display: 'block'
                            }}
                            title="Campaign Dashboard"
                          />
                        </Box>
                      );
                    }}
                  />
                  <Route path={`${this.props.match.path}/competitor-report-dashboard`} 
                    render={({ location }) => {
                      const iframePath = `/competitor-report-dashboard${location.pathname.replace('/planner/competitor-report-dashboard', '')}${location.search}`;
                      return (
                        <ThemeProvider theme={theme}>
                          <Box sx={{ width: '100%', height: 'calc(100vh - 64px)', border: 'none' }}>
                            <iframe
                              key={iframePath}
                              src={iframePath}
                              style={{
                                width: '100%',
                                height: '100%',
                                border: 'none',
                                display: 'block'
                              }}
                              title="Competitor Report Dashboard"
                            />
                          </Box>
                        </ThemeProvider>
                      );
                    }}
                  ></Route>

                  {/* Last, and with no path, so it catches whatever the
                      routes above did not. Without it an unmatched
                      /planner/* address rendered the shell around an empty
                      page and said nothing. */}
                  <Route component={PlannerNotFound} />
                </Switch>
                
                {/* <QuickFilters
                  updateFilters={this.updateFilters}
                /> */}
              </Container>
            </MainContentStyled>
        </Box>
        <PremiunFeature />
      </ThemeCustomization>
    );
  }
}

const mapStateToProps = (state) => ({
  drawerOpen: state.planner2.drawerOpen,
  user : state.planner2.user,
});

const plannerActions = {
  updateUser
};

// export default Planner;
export default withRouter(connect(mapStateToProps, plannerActions)(Planner));